import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageVariables } from '../../shared/constants/app.enum';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  set(key: StorageVariables, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));

    if (key === StorageVariables.TOKEN) {
      window.dispatchEvent(new CustomEvent('tokenChanged', { detail: { token: value } }));
    }
  }

  get(key: StorageVariables): any {
    const item = localStorage.getItem(key);

    if (item) return JSON.parse(item) ? JSON.parse(item) : item;

    return null;
  }

  remove(key: StorageVariables): void {
    localStorage.removeItem(key);

    if (key === StorageVariables.TOKEN) {
      window.dispatchEvent(new CustomEvent('tokenChanged', { detail: { token: null } }));
    }
  }

  clear(): Observable<boolean> {
    return new Observable(observer => {
      localStorage.clear();
      window.dispatchEvent(new CustomEvent('tokenChanged', { detail: { token: null } }));
      observer.next(true);
    });
  }

  hasItem(key: StorageVariables): boolean {
    return !!localStorage.getItem(key);
  }

  setSessionItem(key: StorageVariables, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getSessionItem(key: StorageVariables): any {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeSessionItem(key: StorageVariables): void {
    sessionStorage.removeItem(key);
  }

  clearSession(): void {
    sessionStorage.clear();
  }
}
